import React from 'react';
import { useConfig } from '../context/ConfigContext';

const Header = ({ title, subtitle }) => {
    return (
        <header className="pt-8 sm:pt-12 pb-4 relative z-10 flex flex-col items-center w-full">
            <div className="relative w-full max-w-md px-4 flex flex-col items-center">
                {/* AstraZeneca Logo */}
                <div className="mb-6 w-[150px] sm:w-[200px]">
                    <img 
                        src="/assets/astrazeneca.png" 
                        alt="AstraZeneca" 
                        className="w-full h-auto"
                        loading="eager"
                    />
                </div>

                {/* Main Title Graphic */}
                <div className="w-[80%] max-w-[300px] sm:max-w-[400px]">
                    <img
                        src="/assets/titulo_lazos.png"
                        alt="Lazos 3er Master Class Andino de Enfermedades RarAZ"
                        className="w-full h-auto"
                        loading="eager"
                    />
                </div>

                {/* Optional Page Title & Subtitle */}
                {(title || subtitle) && (
                    <div className="mt-6 text-center animate-fadeInUp">
                        {title && (
                            <h2 className="text-2xl sm:text-4xl font-black text-white uppercase tracking-wider drop-shadow-lg">
                                {title}
                            </h2>
                        )}
                        {subtitle && (
                            <div className="inline-block mt-2 px-4 py-1 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
                                <p className="text-[10px] sm:text-xs font-bold text-white uppercase tracking-widest">
                                    {subtitle}
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
